import {NgModule} from '@angular/core';
import {AppVersionNotifierComponent} from './app-version-notifier.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedProviderModule} from '../../../shared/shared.module';

@NgModule({
  declarations: [AppVersionNotifierComponent],
  imports: [
    SharedProviderModule,
    NgbModule
  ],
  exports: [AppVersionNotifierComponent]
})
export class AppVersionNotifierModule {
}
